import { Tabs } from '@amzn/awsui-components-react'
import { EMPLOYEES_GENERIC } from '../../Constant'
import AllocationHrDataEmployeeTypeTable from './AllocationHrDataEmployeeTypeTable'

const AllocationHrDataTable = (props) => {
    const { isLoading, hrMemberData } = props

    const tabItem = (employee) => {
        const hrMemberDataByType = hrMemberData?.[employee.type] ?? []
        return {
            label: `${employee.name}: ${hrMemberDataByType.length}`,
            id: employee.type,
            content: (
                <AllocationHrDataEmployeeTypeTable
                    isLoading={isLoading}
                    hrMembers={hrMemberDataByType}
                />
            ),
            disabled: !hrMemberDataByType.length,
        }
    }

    return (
        <Tabs
            tabs={EMPLOYEES_GENERIC.map((employee) => {
                return tabItem(employee)
            })}
        />
    )
}

export default AllocationHrDataTable
